var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaymo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.642 59.642",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.424 21.816L22.158 43.13l-9.18-5.283 12.266-21.313zM37.5 37.83l12.266-21.313 9.18 5.283L46.67 43.113z",
    fill: "#0078ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00e89d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.642 19.17c0 2.92-2.377 5.296-5.296 5.296S49.05 22.1 49.05 19.17s2.377-5.296 5.296-5.296c2.938 0 5.296 2.377 5.296 5.296m-42.07 26.612a5.32 5.32 0 0 1-4.604-2.657L.7 21.808a5.28 5.28 0 0 1 1.946-7.224c2.545-1.46 5.783-.6 7.243 1.946l12.258 21.297c1.46 2.545.58 5.783-1.946 7.243a5.22 5.22 0 0 1-2.64.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.088 45.782a5.32 5.32 0 0 1-4.604-2.657L25.226 21.808c-1.46-2.545-.58-5.783 1.946-7.243 2.545-1.46 5.783-.58 7.243 1.946l12.258 21.316c1.46 2.545.58 5.783-1.946 7.243a5.18 5.18 0 0 1-2.639.711z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaymo);
export default __webpack_public_path__ + "static/media/waymo.45be4d517d728509db734e168309a7fe.svg";
export { ForwardRef as ReactComponent };